import { render, staticRenderFns } from "./Remainder-page.vue?vue&type=template&id=dc23c25c&scoped=true&"
import script from "./Remainder-page.vue?vue&type=script&lang=js&"
export * from "./Remainder-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc23c25c",
  null
  
)

export default component.exports